import { get } from 'lodash/fp';

import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isProcessingPostPT: false,
  postPTError: null,
  createdPositionTemplateId: null,
};

export const createPositionTemplateSlice = createSlice({
  name: 'createPositionTemplateSlice',
  initialState,
  reducers: {
    /* eslint-disable no-param-reassign */
    postPositionTemplate: (state) => {
      state.isProcessingPostPT = true;
    },
    postPositionTemplateProcessed: (state) => {
      state.isProcessingPostPT = false;
    },
    postPositionTemplateError: (state, action) => {
      state.isProcessingPostPT = false;
      const messageData =
        get(['payload', 'GLOBAL', 'messageKey'], action) || 'error.generic.something.went.wrong';
      state.postPTError = messageData;
    },
    clearPostPTError: (state) => {
      state.postPTError = null;
    },
    postPositionTemplateV2: (state) => {
      state.isProcessingPostPT = true;
      state.postPTError = null;
      state.createdPositionTemplateId = null;
    },
    postPositionTemplateV2Processed: (state, action) => {
      state.isProcessingPostPT = false;
      state.createdPositionTemplateId = get(['payload', 'data', 'id'], action) || null;
    },
    postPositionTemplateV2Error: (state, action) => {
      state.isProcessingPostPT = false;
      state.postPTError =
        get(['payload', 'errors', 'GLOBAL', 'messageKey'], action) ||
        'error.generic.something.went.wrong';
    },
    clearCreatedPositionTemplate: (state) => {
      state.createdPositionTemplateId = null;
    },
  },
});

export const createPositionTemplateReducer = createPositionTemplateSlice.reducer;

export const {
  postPositionTemplate,
  postPositionTemplateProcessed,
  postPositionTemplateError,
  clearPostPTError,
  postPositionTemplateV2,
  postPositionTemplateV2Processed,
  postPositionTemplateV2Error,
  clearCreatedPositionTemplate,
} = createPositionTemplateSlice.actions;
